import { ArrowRight } from "lucide-react";

const CheckupStickyMobileCta = () => {
  const scrollToForm = () => {
    document.getElementById("checkup-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-hero-bg/95 backdrop-blur-sm border-t border-border p-3">
      <button
        onClick={scrollToForm}
        className="w-full flex items-center justify-center gap-2 bg-accent text-accent-foreground py-3.5 rounded-lg text-sm font-semibold shadow-lg shadow-accent/25 active:scale-[0.97] transition-all"
      >
        Request My Growth Checkup
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default CheckupStickyMobileCta;
